var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail1C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 0H0V225H328V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4194 18.0435H8.60608V22.7704H56.4194V18.0435Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.584 18.0435H113.771V22.7704H161.584V18.0435Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.99 18.0435H61.1769V22.7704H108.99V18.0435Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.154 18.0435H166.341V22.7704H214.154V18.0435Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 63.5137H8.60608V71.1668H29.644V63.5137Z",
    stroke: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 132.389H8.60608V140.042H29.644V132.389Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 55.8584H8.60608V63.5115H29.644V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 71.1655H8.60608V78.8186H29.644V71.1655Z",
    stroke: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 140.045H8.60608V147.698H29.644V140.045Z",
    stroke: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 78.8169H8.60608V86.47H29.644V78.8169Z",
    stroke: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 147.697H8.60608V155.35H29.644V147.697Z",
    stroke: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 86.4722H8.60608V94.1253H29.644V86.4722Z",
    stroke: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 155.349H8.60608V163.002H29.644V155.349Z",
    stroke: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 109.432H8.60608V117.085H29.644V109.432Z",
    stroke: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 178.306H8.60608V185.959H29.644V178.306Z",
    stroke: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 94.124H8.60608V101.777H29.644V94.124Z",
    stroke: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 163.004H8.60608V170.657H29.644V163.004Z",
    stroke: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 117.086H8.60608V124.739H29.644V117.086Z",
    stroke: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 185.96H8.60608V193.613H29.644V185.96Z",
    stroke: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 101.775H8.60608V109.428H29.644V101.775Z",
    stroke: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 170.655H8.60608V178.308H29.644V170.655Z",
    stroke: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.644 124.738H8.60608V132.391H29.644V124.738Z",
    stroke: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 63.5137H117.62V71.1668H150.134V63.5137Z",
    stroke: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 132.389H117.62V140.042H150.134V132.389Z",
    stroke: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 55.8584H117.62V63.5115H150.134V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 71.1655H117.62V78.8186H150.134V71.1655Z",
    stroke: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 140.045H117.62V147.698H150.134V140.045Z",
    stroke: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 78.8169H117.62V86.47H150.134V78.8169Z",
    stroke: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 147.697H117.62V155.35H150.134V147.697Z",
    stroke: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 86.4722H117.62V94.1253H150.134V86.4722Z",
    stroke: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 155.349H117.62V163.002H150.134V155.349Z",
    stroke: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 109.432H117.62V117.085H150.134V109.432Z",
    stroke: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 178.306H117.62V185.959H150.134V178.306Z",
    stroke: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 94.124H117.62V101.777H150.134V94.124Z",
    stroke: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 163.004H117.62V170.657H150.134V163.004Z",
    stroke: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 117.086H117.62V124.739H150.134V117.086Z",
    stroke: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 185.96H117.62V193.613H150.134V185.96Z",
    stroke: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 101.775H117.62V109.428H150.134V101.775Z",
    stroke: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 170.655H117.62V178.308H150.134V170.655Z",
    stroke: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.134 124.738H117.62V132.391H150.134V124.738Z",
    stroke: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 63.5137H150.134V71.1668H173.084V63.5137Z",
    stroke: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 132.389H150.134V140.042H173.084V132.389Z",
    stroke: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 55.8584H150.134V63.5115H173.084V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 71.1655H150.134V78.8186H173.084V71.1655Z",
    stroke: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 140.045H150.134V147.698H173.084V140.045Z",
    stroke: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 78.8169H150.134V86.47H173.084V78.8169Z",
    stroke: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 147.697H150.134V155.35H173.084V147.697Z",
    stroke: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 86.4722H150.134V94.1253H173.084V86.4722Z",
    stroke: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 155.349H150.134V163.002H173.084V155.349Z",
    stroke: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 109.432H150.134V117.085H173.084V109.432Z",
    stroke: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 178.306H150.134V185.959H173.084V178.306Z",
    stroke: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 94.124H150.134V101.777H173.084V94.124Z",
    stroke: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 163.004H150.134V170.657H173.084V163.004Z",
    stroke: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 117.086H150.134V124.739H173.084V117.086Z",
    stroke: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 185.96H150.134V193.613H173.084V185.96Z",
    stroke: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 101.775H150.134V109.428H173.084V101.775Z",
    stroke: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 170.655H150.134V178.308H173.084V170.655Z",
    stroke: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.084 124.738H150.134V132.391H173.084V124.738Z",
    stroke: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 63.5137H173.084V71.1668H200.816V63.5137Z",
    stroke: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 132.389H173.084V140.042H200.816V132.389Z",
    stroke: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 55.8584H173.084V63.5115H200.816V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 71.1655H173.084V78.8186H200.816V71.1655Z",
    stroke: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 140.045H173.084V147.698H200.816V140.045Z",
    stroke: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 78.8169H173.084V86.47H200.816V78.8169Z",
    stroke: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 147.697H173.084V155.35H200.816V147.697Z",
    stroke: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 86.4722H173.084V94.1253H200.816V86.4722Z",
    stroke: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 155.349H173.084V163.002H200.816V155.349Z",
    stroke: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 109.432H173.084V117.085H200.816V109.432Z",
    stroke: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 178.306H173.084V185.959H200.816V178.306Z",
    stroke: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 94.124H173.084V101.777H200.816V94.124Z",
    stroke: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 163.004H173.084V170.657H200.816V163.004Z",
    stroke: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 117.086H173.084V124.739H200.816V117.086Z",
    stroke: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 185.96H173.084V193.613H200.816V185.96Z",
    stroke: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 101.775H173.084V109.428H200.816V101.775Z",
    stroke: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 170.655H173.084V178.308H200.816V170.655Z",
    stroke: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M200.816 124.738H173.084V132.391H200.816V124.738Z",
    stroke: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 63.5137H200.816V71.1668H296.443V63.5137Z",
    stroke: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 132.389H200.816V140.042H296.443V132.389Z",
    stroke: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 55.8584H200.816V63.5115H296.443V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 71.1655H200.816V78.8186H296.443V71.1655Z",
    stroke: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 140.045H200.816V147.698H296.443V140.045Z",
    stroke: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 78.8169H200.816V86.47H296.443V78.8169Z",
    stroke: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 147.697H200.816V155.35H296.443V147.697Z",
    stroke: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 86.4722H200.816V94.1253H296.443V86.4722Z",
    stroke: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 155.349H200.816V163.002H296.443V155.349Z",
    stroke: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 109.432H200.816V117.085H296.443V109.432Z",
    stroke: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 178.306H200.816V185.959H296.443V178.306Z",
    stroke: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 94.124H200.816V101.777H296.443V94.124Z",
    stroke: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 163.004H200.816V170.657H296.443V163.004Z",
    stroke: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 117.086H200.816V124.739H296.443V117.086Z",
    stroke: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 185.96H200.816V193.613H296.443V185.96Z",
    stroke: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 101.775H200.816V109.428H296.443V101.775Z",
    stroke: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 170.655H200.816V178.308H296.443V170.655Z",
    stroke: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M296.443 124.738H200.816V132.391H296.443V124.738Z",
    stroke: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 63.5137H296.443V71.1668H319.394V63.5137Z",
    stroke: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 132.389H296.443V140.042H319.394V132.389Z",
    stroke: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 55.8584H296.443V63.5115H319.394V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 71.1655H296.443V78.8186H319.394V71.1655Z",
    stroke: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 140.045H296.443V147.698H319.394V140.045Z",
    stroke: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 78.8169H296.443V86.47H319.394V78.8169Z",
    stroke: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 147.697H296.443V155.35H319.394V147.697Z",
    stroke: "#CCCCCC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 86.4722H296.443V94.1253H319.394V86.4722Z",
    stroke: "#CCCCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 155.349H296.443V163.002H319.394V155.349Z",
    stroke: "#CCCCCC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 109.432H296.443V117.085H319.394V109.432Z",
    stroke: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 178.306H296.443V185.959H319.394V178.306Z",
    stroke: "#CCCCCC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 94.124H296.443V101.777H319.394V94.124Z",
    stroke: "#CCCCCC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 163.004H296.443V170.657H319.394V163.004Z",
    stroke: "#CCCCCC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 117.086H296.443V124.739H319.394V117.086Z",
    stroke: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 185.96H296.443V193.613H319.394V185.96Z",
    stroke: "#CCCCCC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 101.775H296.443V109.428H319.394V101.775Z",
    stroke: "#CCCCCC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 170.655H296.443V178.308H319.394V170.655Z",
    stroke: "#CCCCCC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 124.738H296.443V132.391H319.394V124.738Z",
    stroke: "#CCCCCC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 63.5137H29.6437V71.1668H117.62V63.5137Z",
    stroke: "#CCCCCC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 132.389H29.6437V140.042H117.62V132.389Z",
    stroke: "#CCCCCC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 55.8584H29.6437V63.5115H117.62V55.8584Z",
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 71.1655H29.6437V78.8186H117.62V71.1655Z",
    stroke: "#CCCCCC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 140.045H29.6437V147.698H117.62V140.045Z",
    stroke: "#CCCCCC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 78.8169H29.6437V86.47H117.62V78.8169Z",
    stroke: "#CCCCCC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 147.697H29.6437V155.35H117.62V147.697Z",
    stroke: "#CCCCCC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 86.4722H29.6437V94.1253H117.62V86.4722Z",
    stroke: "#CCCCCC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 155.349H29.6437V163.002H117.62V155.349Z",
    stroke: "#CCCCCC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 109.432H29.6437V117.085H117.62V109.432Z",
    stroke: "#CCCCCC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 178.306H29.6437V185.959H117.62V178.306Z",
    stroke: "#CCCCCC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 94.124H29.6437V101.777H117.62V94.124Z",
    stroke: "#CCCCCC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 163.004H29.6437V170.657H117.62V163.004Z",
    stroke: "#CCCCCC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 117.086H29.6437V124.739H117.62V117.086Z",
    stroke: "#CCCCCC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 185.96H29.6437V193.613H117.62V185.96Z",
    stroke: "#CCCCCC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 101.775H29.6437V109.428H117.62V101.775Z",
    stroke: "#CCCCCC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 170.655H29.6437V178.308H117.62V170.655Z",
    stroke: "#CCCCCC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M117.62 124.738H29.6437V132.391H117.62V124.738Z",
    stroke: "#CCCCCC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1075 8.58936H8.60608V13.3163H85.1075V8.58936Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M319.394 30.3325H8.60608V32.2233H319.394V30.3325Z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6702 41.6782H8.60608V46.405H94.6702V41.6782Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M142.459 41.6782H99.4269V46.405H142.459V41.6782Z",
    fill: "#E0E0E0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M190.272 41.6782H147.241V46.405H190.272V41.6782Z",
    fill: "#E0E0E0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1843 201.446C12.6039 204.577 10.5998 210.959 11.9124 214.003C12.6426 215.697 13.5667 213.423 14.0084 212.553C15.198 210.208 15.6472 207.42 16.9106 205.119C18.3409 202.512 18.2174 202.858 18.5228 205.617C18.7867 208 18.9139 210.41 19.2394 212.78C19.3767 213.778 19.3733 214.348 19.8127 212.983C20.4774 210.919 21.2993 209.386 22.3923 207.656C22.8863 206.876 23.1806 205.958 23.1806 207.43C23.1806 207.792 23.1149 214.085 23.7539 213.187C23.9895 212.856 24.094 211.7 24.3092 211.215C24.7229 210.285 25.0637 209.429 25.5811 208.586C25.8022 208.227 25.6436 207.599 26.0827 207.566C27.4856 207.462 28.9492 208.025 30.3464 208.133C36.6714 208.621 39.5724 207.566 45.9005 207.566",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2003 206.876C66.5096 206.459 62.8057 206.654 59.1222 206.254C59.0799 206.25 56.937 205.826 57.8016 205.912C61.541 206.283 65.2335 206.822 68.9927 206.862C73.8819 206.913 78.7133 206.132 83.5907 205.919C86.007 205.812 88.4488 205.785 90.8458 206.261L70.2003 206.876ZM69.296 215.627C69.4517 213.03 69.6425 208.576 69.5117 205.976C69.4501 204.752 69.308 203.559 69.296 202.331C69.2949 202.215 69.2913 201.525 69.1828 201.46C69.0452 201.378 68.9354 201.695 68.818 201.825C68.0073 202.719 67.202 203.619 66.403 204.532C64.1276 207.137 61.8911 209.91 59.3739 212.063C58.6113 212.716 57.8265 213.322 57.036 213.906C56.8459 214.046 56.2529 214.374 56.4656 214.329C56.8344 214.249 57.257 213.986 57.6012 213.835C58.7057 213.35 59.8158 212.902 60.9359 212.492C62.4318 211.944 68.0074 210.319 69.5328 209.955L69.296 215.627Z",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail1C);
export default __webpack_public_path__ + "static/media/thumbnail-1-c.54823815bbeebc45e5369eb5bf754761.svg";
export { ForwardRef as ReactComponent };